import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ClientUser } from '@weblite/ts-action/client-user'
import { clientUserView } from '$logic/client-user/storage'
import { supportAccountIds } from '$logic/client-user/constants'

export function useClientUser() {
  return useSelector(clientUserView) || ({} as ClientUser)
}

export function useIsClientUserSupport() {
  const clientUser = useClientUser()
  return useMemo(() => {
    return supportAccountIds.includes(clientUser.id)
  }, [clientUser])
}
